/* Copyright (c) 2021-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { BaseConfigType } from 'app-config';
import { JsEventsServerConfig } from 'js-events';
import { StarfleetConfig } from 'starfleet';
import { NetworkHttpEndpointRetryConfig, RetryConfig } from 'nv-angular-http-endpoint';

export interface LcarsConfig {
    serverUrl: string;
    serverUrlCDN: string;
    clientId: string;
    cascadeHeaderValue?: string;
    stageHeaderValue?: string;
    retryOnTimeout?: boolean;
    exponentialBackoffMaxDelay?: number;
    retryConfig?: RetryConfig;
}

export interface GridConfig {
    serviceUrlsUrl: string;
    server?: string;
    version: string;
}

export interface VdkPlaytestConfiguration {
    ptmsUrl: string;
    publicLearnArticlesUrl: string;
    publicLearnImagesBaseUrl: string;
    publicLearnArticlesBaseUrl: string;
}

export class Configuration implements BaseConfigType {
    starfleet?: StarfleetConfig;
    lcars?: LcarsConfig;
    grid?: GridConfig;
    jsEvents?: JsEventsServerConfig;
    vdkPlaytestConfig?: VdkPlaytestConfiguration;
    networkHttpEndpointRetryConfig?: NetworkHttpEndpointRetryConfig;
}
